export class Experiment {
    constructor(id, name, group) {
        this.id = id;
        this.name = name;
        this.group = group;
    }
}
//# sourceMappingURL=Experiment.js.map